import Block1Background from './block1background.png';
import Block2FruitBar from './fruit-bars.png';

let GridBlocksData = [
    {
        "header": true,
        "image": Block1Background,
        "imageAlt": "Background"
    },
    {
        "image": Block2FruitBar,
        "imageAlt": "Fruit Bars",
        "text": "Solero® fruit bars and pops are available at various retailers nationwide. Find one near you! "
    }
];

export default GridBlocksData;


// WEBPACK FOOTER //
// ./src/views/whereToBuy/GridBlocksData.js